<template>
  <div>
    <p class="text-bold text-primary q-mb-xs">
      当前详情
    </p>

    <Loading v-if="loadingAll" />
    <div v-else-if="Object.keys(all).length">
      <div
        class="agg-item row items-center justify-between text-caption"
        v-for="key of Object.keys(all)"
        :key="key"
      >
        <span>{{ key }}:</span>
        <span>{{ all[key] }}</span>
      </div>
    </div>
    <Empty v-else />

    <p class="text-bold text-primary q-mt-lg q-mb-xs">
      当日详情
    </p>
    <Loading v-if="loadingDay" />
    <div v-else-if="Object.keys(day).length">
      <div
        class="agg-item row items-center justify-between text-caption"
        v-for="key of Object.keys(day)"
        :key="key"
      >
        <span>{{ key }}:</span>
        <span>{{ day[key] }}</span>
      </div>
    </div>
    <Empty v-else />
  </div>
</template>

<script>
import { aggStatusAll } from "@/api/endpoints/agg/aggStatusAll";
import { aggStatusDay } from "@/api/endpoints/agg/aggStatusDay";
import AggMixin from "./agg.mixin";

export default {
  mixins: [AggMixin],
  components: {
    Loading: () => import("@/components/Loading"),
    Empty: () => import("@/components/Empty"),
  },

  data() {
    return {
      all: {},
      day: {},
      loadingAll: false,
      loadingDay: false,
    };
  },
  methods: {
    agg() {
      this._aggStatusAll();
      this._aggStatusDay();
    },
    async _aggStatusAll() {
      try {
        this.loadingAll = true;
        const response = await aggStatusAll();
        if (!response || response.err || response.message)
          throw Error(response.detail || response.message);
        this.all = response;
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: err.toString(),
        });
      } finally {
        this.loadingAll = false;
      }
    },

    async _aggStatusDay() {
      try {
        this.loadingDay = true;
        const _date = this.date;
        const d = new Date(_date);
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const date = d.getDate();
        const response = await aggStatusDay({ year, month, date });
        if (!response || response.err || response.message)
          throw Error(response.detail || response.message);
        this.day = response;
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: err.toString(),
        });
      } finally {
        this.loadingDay = false;
      }
    },
  },
};
</script>

<style lang="scss">
.agg-item {
  transition: all 0.3s ease;
  border-radius: 5px;
  &:hover {
    padding: 10px;
    background-color: var(--q-color-primary);
    color: #fff;
    font-weight: bold;
  }
}
</style>
